import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { LegendItem, LegendLabel, LegendOrdinal } from '@visx/legend';
import { scaleOrdinal } from '@visx/scale';

import { COLOR_WHEEL } from '../../constants';

export const MultiBarLegend = ({ keys }: { keys: string[] }) => {
  return (
    <Box display="flex" justifyContent="center" mt={-3}>
      <LegendOrdinal
        scale={scaleOrdinal({
          domain: keys,
          range: COLOR_WHEEL.slice(0, keys.length),
        })}
      >
        {(labels) => (
          <Stack alignItems="center" direction="row" gap={1}>
            {labels.map((label, i) => (
              <LegendItem key={`legend-quantile-${i}`}>
                <Stack alignItems={'center'} direction="row" gap={1}>
                  <svg height={15} width={15}>
                    <rect fill={label.value} height={15} width={15} />
                  </svg>
                  <LegendLabel align="left">{label.text}</LegendLabel>
                </Stack>
              </LegendItem>
            ))}
          </Stack>
        )}
      </LegendOrdinal>
    </Box>
  );
};
